import React from "react";
import "../ProductCardsModems.css";
import { Link } from "react-router-dom"; 
import '../../i18n';
import { useTranslation } from 'react-i18next';

import ImageSpin12Transponder from "../../assets/images/modems/processed/combined_transponder_spin12.png"

const Spin12_BEACON = () => {
  const { t, i18n } = useTranslation();
  
  return (
     <Link to="/acoustic_modems#spin12_beacon_spec" className="card-link-wrapper"> {/* Wrap card with Link */}
          <div className="card-beacon">
            <img src={ImageSpin12Transponder} alt={t('products.types.communcation_12_BEACON.title')} className="card-image-beacon" />
            <div className="card-content">
              <h3 className="card-title">{t('products.types.communcation_12_BEACON.title')}</h3>
              <p className="card-description">
                <ul class="features-list">
                  <li>{t('products.types.communcation_12_BEACON.li_1')}</li>
                  <li>{t('products.types.communcation_12_BEACON.li_2')}</li>
                  <li>{t('products.types.communcation_12_BEACON.li_3')}</li>
                  <li>{t('products.types.communcation_12_BEACON.li_4')}</li>
                  <li>{t('products.types.communcation_12_BEACON.li_5')}</li>
                  <li>{t('products.types.communcation_12_BEACON.li_6')}</li>
                </ul>
              </p>
            </div>
          </div>
        </Link>
  );
};
export default Spin12_BEACON;